export function normalizePortalRole(role) {
  return String(role || "").trim().toLowerCase();
}

export function isPortalRole(role) {
  const normalized = normalizePortalRole(role);
  return normalized === "customer" || normalized === "distributor";
}

export function isDistributorRole(role) {
  return normalizePortalRole(role) === "distributor";
}

export function isCustomerRole(role) {
  return normalizePortalRole(role) === "customer";
}

export function isManufacturingRole(role) {
  const normalized = normalizePortalRole(role);
  return !!normalized && !isPortalRole(normalized);
}
